export type MediaSrc = string | { src: string };

export const getUrlForSrc = (src: MediaSrc): string => {
  if (!src) return "";
  return typeof src === "string" ? src : src.src;
};
